import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'top_match_event_cell';
export const useTopMatchEventCellTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => {
  return useTranslation('entities', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    no_face: 'Не найдено лицо из совпадения',
    no_body: 'Не найдено тело из совпадения',
    tag: 'Событие',
    external_id: 'Внешний ID',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    no_face: 'No face found from match',
    no_body: 'No body found from match',
    tag: 'Event',
    external_id: 'External ID',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    no_face: 'Nenhum rosto encontrado na correspondência',
    no_body: 'Nenhum corpo encontrado na correspondência',
    tag: 'Evento',
    external_id: 'ID externo',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    no_face: 'No se encontró ningún rostro de la coincidencia',
    no_body: 'No se encontró ningún cuerpo de la coincidencia',
    tag: 'Evento',
    external_id: 'ID externo',
  },
}) as Record<string, unknown>;
